import { render, staticRenderFns } from "./snapPosition.vue?vue&type=template&id=2ea90484&scoped=true&"
import script from "./snapPosition.vue?vue&type=script&lang=js&"
export * from "./snapPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea90484",
  null
  
)

export default component.exports